module.exports = __webpack_public_path__ + "img/PM_A02_back_cross_en.84676a3a.png";